<template>
  <transition name="fade">
    <div class="page-container">
      <div v-if="isLoading" style="padding-top: 15vh">
        <PleaseWait></PleaseWait>
      </div>

      <ForgotPasswordModal
        v-else-if="isForgotPasswordModalVisible"
        @close="closeModal"
      ></ForgotPasswordModal>

      <template v-else>
        <CommunityCard class="login-container">
          <form class="form-login" @submit.prevent="auth">
            <div class="text-center" style="margin-bottom: 5rem">
              <img
                width="260"
                src="./assets/iSimulate-Logo.svg"
                alt="iSimulate logo"
              />
            </div>

            <div v-if="invalidAuth" class="text-danger mb-2">
              Incorrect username or password!
            </div>
            <div v-if="unverifiedAccount" class="text-danger mb-2">
              {{ unverifiedMsg }}
              <p v-if="unverifiedMsg !== 'Email sent!'">
                <small>
                  If you didn't receive the email, please click
                  <button class="link" @click.prevent="resendEmail()">
                    here
                  </button>
                  to re-send it.
                </small>
              </p>
            </div>

            <div v-if="userJustVerified" class="text-success mb-2">
              Your account was verified. Please login below.
            </div>

            <label for="inputEmail" class="sr-only">Email address</label>
            <input
              type="text"
              id="inputEmail"
              class="form-control text-inp mb-4"
              placeholder="Username"
              autofocus
              autocomplete="username"
              autocapitalize="none"
              v-model="currentUsername"
            />
            <label for="inputPassword" class="sr-only">Password</label>
            <input
              type="password"
              id="inputPassword"
              class="form-control text-inp"
              placeholder="Password"
              autocomplete="current-password"
              v-model="currentPassword"
            />
            <div class="forgot-btn mt-1 mb-4" @click="showModal()">
              Forgotten Password?
            </div>

            <button class="btn btn-lg btn-block my-3 login-btn" type="submit">
              Sign in
            </button>

            <div class="mt-5 text-center">
              <div>No account?</div>
              <router-link
                tag="button"
                class="btn register-btn mt-2 px-4"
                to="/register"
              >
                Register Now
              </router-link>
            </div>
          </form>
        </CommunityCard>

        <div class="text-center footer mt-4">
          <router-link tag="button" class="btn" to="/terms">
            Terms and Conditions
          </router-link>
        </div>
      </template>
    </div>
  </transition>
</template>

<script>
import UserService from "./services/user.service";
import logger from "./utils/logger";
import ForgotPasswordModal from "./components/ForgotPasswordModal";
import CommunityCard from "./components/CommunityCard";
import PleaseWait from "./components/PleaseWait";

export default {
  name: "Login",
  computed: {
    userJustVerified() {
      return this.$store.getters.getUserJustVerified;
    },
    currentDistributor() {
      return this.$store.getters.getDistributor;
    },
  },
  data() {
    return {
      isForgotPasswordModalVisible: false,
      invalidAuth: false,
      unverifiedAccount: false,
      unverifiedMsg: "",
      sendingEmail: false,
      currentUsername: "",
      currentPassword: "",
      userEmail: "",
      isLoading: false,
    };
  },
  components: {
    ForgotPasswordModal,
    PleaseWait,
    CommunityCard,
  },
  methods: {
    auth: function () {
      this.invalidAuth = false;
      this.unverifiedAccount = false;
      this.isLoading = true;

      this.$store.commit("setUserJustVerified", false);

      UserService.auth(
        this.currentUsername,
        this.currentPassword,
        this.currentDistributor
      ).catch((error) => {
        this.isLoading = false;

        let err = JSON.parse(error.message);
        if (
          err.hasOwnProperty("message") &&
          err.message.includes("Unverified account")
        ) {
          this.unverifiedMsg = err.message;
          this.unverifiedAccount = true;
          this.userEmail = err.email || "";
        } else {
          this.invalidAuth = true;
        }
      });
    },
    resendEmail() {
      if (this.sendingEmail) return;
      this.sendingEmail = true;

      UserService.resendVerificationEmail(this.userEmail, this.currentDistributor)
        .then(() => (this.unverifiedMsg = "Email sent!"))
        .catch((err) => logger.error("auth.resend_verification.failure", err))
        .finally(() => (this.sendingEmail = false));
    },
    showModal() {
      this.isForgotPasswordModalVisible = true;
    },
    closeModal() {
      this.isForgotPasswordModalVisible = false;
    },
  },
};
</script>

<style scoped>
.page-container {
  margin: 5vh auto;
}

.login-container {
  max-width: 600px;
  margin: 0 auto;
}

.form-login {
  max-width: 360px;
  margin: 80px auto 60px;
}

.link {
  border-radius: 3px;
}

.text-inp {
  background: #f7f7f7;
}

.forgot-btn {
  color: var(--isim-primary);
  font-size: 0.75rem;
  font-weight: 100;
  text-decoration: underline;
  cursor: pointer;
}

.login-btn {
  background: var(--isim-primary);
  color: white;
}

.register-btn {
  border: 1px solid var(--isim-warning);
  font-size: 1.3em;
  color: var(--isim-warning);
}

.footer {
  padding-bottom: 2vh;
}
</style>
